import { getSissiCoreUrl } from '../../config/server';

function getChannelsWithSecurePayment() {
  const url = `${getSissiCoreUrl()}/channelsWithSecurePayment`;
  return fetch(url, { credentials: 'include' })
    .then(res => res.json())
    .catch(() => Promise.resolve([]));
}

function saveChannelWithSecurePayment(instance) {
  const url = `${getSissiCoreUrl()}/channelsWithSecurePayment/${instance.id ? 'edit' : 'create'}${instance.id ? `/${instance.id}` : ''}`;
  return fetch(
    url,
    {
      method: instance.id ? 'PUT' : 'POST',
      credentials: 'include',
      body: JSON.stringify(instance),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    })
    .then(res => res.json())
    .then(json => json.error ? Promise.resolve(null) : Promise.resolve(json))
    .catch(() => Promise.resolve(null));
}

function deleteChannelWithSecurePayment(instance) {
  const url = `${getSissiCoreUrl()}/channelsWithSecurePayment/delete/${instance.id}`;
  return fetch(url, { method: 'DELETE', credentials: 'include' })
    .then(() => Promise.resolve(true))
    .catch(() => Promise.resolve(false));
}

export { getChannelsWithSecurePayment, saveChannelWithSecurePayment, deleteChannelWithSecurePayment };
